import type { ButtonOrLinkOwnProps } from '#/components/ButtonOrLink/ButtonOrLink';
import type { ButtonOrLinkDataProps } from '#/components/ButtonOrLink/ButtonOrLinkData';

import { ButtonOrLinkStyledAsHyperlink } from './Hyperlink.styled';

type Props = ButtonOrLinkDataProps<ButtonOrLinkOwnProps>;

export function Hyperlink(props: Props) {
  // While we could just have a styled-component here, this component exists because
  // we're likely to add variants or customizations to it.

  return (
    <ButtonOrLinkStyledAsHyperlink
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
